import { DEFAULT_LOCALE, FALLBACK_LOCALE, type Locale } from '@kidshub/contracts';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json' with { type: 'json' };
import tr from '../locales/tr.json' with { type: 'json' };

/**
 * Turkish is the default; English is the fallback.
 *
 * A key missing from `tr` is a defect rather than something the fallback should
 * paper over, so `pnpm i18n:check` fails the build on an incomplete locale
 * (AGENTS.md §1.2). No component may hold a user-facing string literal.
 */
export const initialiseI18n = async (locale: Locale = DEFAULT_LOCALE): Promise<void> => {
  await i18next.use(initReactI18next).init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    lng: locale,
    fallbackLng: FALLBACK_LOCALE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
};

export { i18next };
